import { t } from "./i18n";
import "./styles.css";
import "./loading.css";
import "./resident.css";
import "./editor-responsive.css";
import "./city-interface.css";
import { CityApi } from "./api/client";
import { chooseEntryCountry } from "./ui/WorldEntry";
import { CityApp } from "./app/CityApp";

document.documentElement.dataset.cityRuntime = "pixi-v3-production";
document.documentElement.dataset.cityInterface = "atlas";

const LOADER_HTML = `
  <div id="city-loading" class="city-boot" role="status" aria-live="polite" aria-label="${t("Loading city")}">
    <div class="city-boot__ambient city-boot__ambient--one" aria-hidden="true"></div>
    <div class="city-boot__ambient city-boot__ambient--two" aria-hidden="true"></div>
    <div class="city-boot__content">
      <div class="city-boot__brand">
        <span class="city-boot__brand-mark">KS</span>
        <span class="city-boot__brand-copy"><strong>Website City</strong><small>Keystone Seller</small></span>
      </div>
        <div class="city-boot__scene" aria-hidden="true">
          <svg class="city-boot__shop" viewBox="0 0 440 290" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
            <defs>
              <linearGradient id="cityBootPlinth" x1="126" y1="174" x2="336" y2="236" gradientUnits="userSpaceOnUse"><stop stop-color="#76d5b5"/><stop offset="1" stop-color="#29a899"/></linearGradient>
              <linearGradient id="cityBootRoof" x1="158" y1="78" x2="309" y2="155" gradientUnits="userSpaceOnUse"><stop stop-color="#ffb46e"/><stop offset=".52" stop-color="#ff797d"/><stop offset="1" stop-color="#aa78e8"/></linearGradient>
              <linearGradient id="cityBootGlass" x1="171" y1="156" x2="252" y2="222" gradientUnits="userSpaceOnUse"><stop stop-color="#92eadb"/><stop offset="1" stop-color="#2e849e"/></linearGradient>
            </defs>
            <ellipse class="city-boot__shop-shadow" cx="232" cy="236" rx="120" ry="23" fill="#000" opacity=".26"/>
            <g class="city-boot__stage city-boot__stage--ground">
              <path d="M122 184 231 124 342 184 233 244Z" fill="url(#cityBootPlinth)" stroke="#bcf6d8" stroke-width="2"/>
              <path d="M122 184 233 244V256L122 196Z" fill="#287c76"/>
              <path d="M233 244 342 184V196L233 256Z" fill="#1e5d72"/>
              <path d="m137 185 96 52 93-52" stroke="#dbffeb" stroke-opacity=".45" stroke-width="2"/>
              <path d="m180 210 12 7m99-6 13-7" stroke="#d7ffe6" stroke-opacity=".75" stroke-width="3" stroke-linecap="round"/>
            </g>
            <g class="city-boot__stage city-boot__stage--walls">
              <path d="m159 119 74 42v70l-74-42Z" fill="#ffdfc8" stroke="#ffd9b5" stroke-width="1.5"/>
              <path d="m233 161 78-42v70l-78 42Z" fill="#fff0dd" stroke="#ffe0bc" stroke-width="1.5"/>
              <path d="m233 161 0 70" stroke="#b99f96" stroke-opacity=".5" stroke-width="2"/>
              <path d="m161 186 71 41m3 0 73-40" stroke="#d2ae93" stroke-opacity=".35" stroke-width="2"/>
            </g>
            <g class="city-boot__stage city-boot__stage--roof">
              <path d="m153 117 80-45 83 46-83 46Z" fill="url(#cityBootRoof)" stroke="#ffe3bf" stroke-width="2"/>
              <path d="m153 117 80 47v10l-80-47Z" fill="#d76d81"/>
              <path d="m233 164 83-46v10l-83 46Z" fill="#9161b7"/>
              <path d="m174 115 59-33 61 34" stroke="#fff3de" stroke-opacity=".6" stroke-width="2" stroke-linecap="round"/>
            </g>
            <g class="city-boot__stage city-boot__stage--front">
              <path d="m172 150 55 31v39l-55-31Z" fill="#356b79" stroke="#fff2de" stroke-width="3" stroke-linejoin="round"/>
              <path d="m175 155 49 28v32l-49-28Z" fill="url(#cityBootGlass)"/>
              <path d="m199 169 0 34m-23-32 47 27" stroke="#fff3df" stroke-opacity=".8" stroke-width="2"/>
              <path d="m254 177 34-19v51l-34 19Z" fill="#385e75" stroke="#f9d7ad" stroke-width="3" stroke-linejoin="round"/>
              <path d="m257 181 28-16v36l-28 16Z" fill="#53b5bd"/>
              <circle cx="278" cy="192" r="2.5" fill="#fff5dc"/>
              <path d="m161 143 73 41v15l-73-41Z" fill="#fff4df"/>
              <path d="m161 143 12 7v15l-12-7Zm24 13 12 7v15l-12-7Zm24 14 12 7v15l-12-7Z" fill="#fc6d87"/>
              <path d="m173 150 12 6v15l-12-6Zm24 13 12 7v15l-12-7Zm24 14 13 7v15l-13-7Z" fill="#ffc54e"/>
              <path d="m161 158 73 41" stroke="#b85a76" stroke-opacity=".6" stroke-width="2"/>
            </g>
            <g class="city-boot__stage city-boot__stage--sign">
              <path d="m182 118 53 30v20l-53-30Z" fill="#174c5f" stroke="#7cebd0" stroke-width="2" stroke-linejoin="round"/>
              <circle cx="195" cy="134" r="4" fill="#ffc857"/>
              <path d="m206 139 20 11m-20-4 13 7" stroke="#f5fffa" stroke-width="2.5" stroke-linecap="round"/>
            </g>
            <g class="city-boot__stage city-boot__stage--decor">
              <path d="m305 197 22-12 0 19-22 12Z" fill="#cb806a"/>
              <path d="m305 197 22-12-12-7-22 12Z" fill="#ffac83"/>
              <path d="m293 190 12 7v19l-12-7Z" fill="#a95d57"/>
              <path d="m310 189 0-32" stroke="#357f70" stroke-width="5" stroke-linecap="round"/>
              <circle cx="310" cy="153" r="18" fill="#50c79b"/>
              <circle cx="298" cy="149" r="11" fill="#86e3a6"/>
              <circle cx="322" cy="145" r="10" fill="#b5e9a0"/>
              <path d="m132 181 14 8v16l-14-8Z" fill="#b86c66"/>
              <path d="m132 181 14 8 10-6-14-8Z" fill="#ffbd7c"/>
              <path d="m146 189 10-6v16l-10 6Z" fill="#97555e"/>
              <path d="m144 179 0-21" stroke="#3fa98b" stroke-width="3" stroke-linecap="round"/>
              <circle cx="139" cy="160" r="7" fill="#ff8c9c"/>
              <circle cx="150" cy="158" r="7" fill="#ffcf6d"/>
              <circle cx="144" cy="151" r="6" fill="#b28ef2"/>
            </g>
            <g class="city-boot__paint city-boot__paint--a">
              <circle cx="108" cy="97" r="17" fill="#f97391" stroke="#ffd9df" stroke-width="3"/>
              <path d="m102 97 5 5 9-11" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <g class="city-boot__paint city-boot__paint--b">
              <circle cx="344" cy="94" r="14" fill="#ffc857" stroke="#fff1c2" stroke-width="3"/>
              <path d="m339 94 4 4 7-8" stroke="#67431b" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <g class="city-boot__paint city-boot__paint--c">
              <circle cx="360" cy="179" r="12" fill="#69ddba" stroke="#c8fff0" stroke-width="3"/>
              <path d="m355 179 4 4 6-8" stroke="#18545e" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <g class="city-boot__spark city-boot__spark--a" fill="#ffdc83"><path d="m130 110 4 10 10 4-10 4-4 10-4-10-10-4 10-4Z"/></g>
            <g class="city-boot__spark city-boot__spark--b" fill="#94efdd"><path d="m333 123 3 7 7 3-7 3-3 7-3-7-7-3 7-3Z"/></g>
          </svg>
        </div>
      <div class="city-boot__copy">
        <strong data-city-loading-title>${t("Preparing the city")}</strong>
        <span data-city-loading-message>${t("Loading streets, buildings and shops…")}</span>
      </div>
      <div class="city-boot__progress" aria-hidden="true"><span></span></div>
    </div>
  </div>`;

function ensureLoader(): HTMLElement {
  const existing = document.getElementById("city-loading");
  if (existing) return existing;

  const template = document.createElement("template");
  template.innerHTML = LOADER_HTML.trim();
  const loader = template.content.firstElementChild as HTMLElement | null;
  if (!loader) throw new Error("Unable to create city loading screen");
  document.body.appendChild(loader);
  return loader;
}

function nextFrame(): Promise<void> {
  return new Promise((resolve) => requestAnimationFrame(() => resolve()));
}

async function revealCity(host: HTMLElement, loader: HTMLElement): Promise<void> {
  // One compositor frame is sufficient after CityApp's initial explicit render.
  // Waiting for a second frame only prolongs the splash on mobile devices.
  await nextFrame();

  host.removeAttribute("aria-busy");
  document.body.classList.add("city-runtime-ready");
  document.body.classList.remove("city-loading-active");
  loader.classList.add("city-boot--leaving");

  await new Promise<void>((resolve) => {
    // The transition is 160ms; keep a small fallback for reduced-motion mode.
    const timeout = window.setTimeout(resolve, 190);
    loader.addEventListener("transitionend", () => {
      window.clearTimeout(timeout);
      resolve();
    }, { once: true });
  });

  loader.remove();
}

function showLoadingError(loader: HTMLElement): void {
  document.body.classList.add("city-loading-active");
  document.body.classList.remove("city-runtime-ready");
  loader.classList.remove("city-boot--leaving");
  loader.classList.add("city-boot--error");

  const title = loader.querySelector<HTMLElement>("[data-city-loading-title]");
  const message = loader.querySelector<HTMLElement>("[data-city-loading-message]");
  if (title) title.textContent = t("The city could not be loaded");
  if (message) message.textContent = t("There was a problem connecting or loading city files. Reload the page.");
}

async function boot(): Promise<void> {
  const host = document.getElementById("city-pixi-root");
  if (!host) throw new Error("Missing #city-pixi-root");

  const loader = ensureLoader();
  document.body.classList.add("city-loading-active");
  host.setAttribute("aria-busy", "true");

  const api = new CityApi();
  await chooseEntryCountry(loader, api);
  const runtime = await api.runtime();
  if (runtime.city?.slug) api.setCitySlug(runtime.city.slug);
  const city = new CityApp(host, runtime, api);
  const editorMode = document.body.dataset.cityEditor === "true";
  await city.start(editorMode);
  await revealCity(host, loader);

  window.addEventListener("beforeunload", () => city.destroy(), { once: true });
}

boot().catch((error) => {
  console.error(error);
  const loader = ensureLoader();
  showLoadingError(loader);
});
